Ext.define('SA.NotificationsMenuController', {
    statics: {
        create({pageHeader, notifications}) {
            var data = notifications.slice().sort((a, b) => b.getDate() - a.getDate()), 
                controller = new SA.NotificationsMenuController({pageHeader, data}),
                toolbarButtonClickHandler = controller.onToolbarButtonClick.bind(controller);

            pageHeader.el.on('click', toolbarButtonClickHandler, null, {delegate: '.sa-page-header-notifications-button'});
        }
    },

    constructor({pageHeader, data}) {
        this.pageHeader = pageHeader;
        this.data = data;
        this.menu = null;
    },

    createNotificationCmp(notification) {
        return Ext.widget({
            xtype: 'notification',
            title: Ext.String.htmlEncode(notification.getTitleText()),
            messageHtml: notification.getMessageHtml()
        });
    },

    getMenuItem(notification) {
        return {
            xtype: 'notifications-menu-item',
            listeners: {el: {click: this.onMenuItemClick.bind(this, notification.getId())}},

            data: {
                didRead: notification.didRead(),
                date: notification.getDate(),
                titleText: notification.getTitleText()
            }
        };
    },

    getNoNotificationsMessage() {
        return {
            xtype: 'component',
            cls: 'sa-notifications-menu-no-notifications-message',
            html: 'No notifications in the last twelve months.'
        };
    },

    onMenuItemClick(notificationId) {
        var notification = this.data.find(notification => notification.id === notificationId),
            notificationCmp = this.createNotificationCmp(notification);

        this.menu.hide();

        if (!notification.didRead()) {
            notification.markRead();
            notificationCmp.on('destroy', () => SA.model.Notices.acknowledge({id: notificationId}));
        }
    },

    onToolbarButtonClick(ev, toolbarButtonEl) {
        if (this.menu?.wasRecentlyVisible()) {
            return;
        }

        this.showmMenu({toolbarButtonEl});

        var unlistedNotifications = this.data.filter(notification => !notification.didList());

        if (unlistedNotifications.length > 0) {
            let ids = unlistedNotifications.map(notification => notification.getId());

            SA.model.Notices.markListed({ids});
            unlistedNotifications.forEach(notification => notification.markListed());
            this.pageHeader.refresh();
        }
    },

    showmMenu({toolbarButtonEl}) {
        var menuItems = (this.data.length === 0)
                ? [this.getNoNotificationsMessage()]
                : this.data.map(notification => this.getMenuItem(notification)),
            menu = this.menu = Ext.widget({
                xtype: 'menu',
                cls: 'sa-notifications-menu',
                items: menuItems,
                maxHeight: Ext.dom.Element.getViewportHeight() * 0.75,
                plugins: [{ptype: 'sa-arrow', bias: 0.2}],
                track: true
            });

        menu.on('hide', () => setTimeout(() => menu.destroy()));

        this.pageHeader.showMenuAtTarget(menu, toolbarButtonEl);
    }
});